class Filters {
  static tabMappings: Record<string, string> = {
    buyers_alert: 'BUYERS_ALERT',
    sales_offers: 'SALES_OFFER',
    'product-company-tab': 'PRODUCT_COMPANY_TAB',
    'company-tab': 'COMPANY_TAB',
    'product-tab': 'PRODUCT_TAB',
    'news-tab': 'NEWS_TAB',
    news: 'NEWS',
  }

  static getTab(pathName: string): string {
    for (const [key, value] of Object.entries(Filters.tabMappings)) {
      if (pathName.includes(key)) {
        return value
      }
    }

    return 'UNKNOWN'
  }

  static getKeysByValue(value: string): string {
    for (const [key, val] of Object.entries(Filters.tabMappings)) {
      if (val === value) {
        return key
      }
    }
    return ''
  }
}

export default Filters
